module.exports = __webpack_public_path__ + "static/media/youssef3.22017ce6.webp";